module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar_header"
  }, _vm._l((_vm.daysOfWeek), function(day, index) {
    return _c('div', {
      key: index,
      staticClass: "header_block"
    }, [_vm._v(_vm._s(_vm.getDay(index)))])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5216e618","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/schedulecalendar/CalendarHeader.vue
// module id = e9a9c81f96868975e0e3
// module chunks = 6